/*
 * loading Sagas
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 04-Sep-2024
*/

import { put, take, all, select } from 'redux-saga/effects'
import { doLocalLoading } from 'Store/actions/loading'

// @generator saga

// @generator saga:watch

function * watchSetLoading () {
  while (true) {
    const action = yield take(act => /_request$/.test(act.type))
    if (action.payload && action.payload.loading) {
      const actionTypeMatch = action.type.match(/\/([^/]+)_request$/)
      if (actionTypeMatch && actionTypeMatch.length > 1) {
        yield put(doLocalLoading({ key: actionTypeMatch[1], value: true }))
      }
    }
  }
}

function * watchUnSetLoading () {
  while (true) {
    const action = yield take(act => /(_failure|_success)$/.test(act.type))
    const actionTypeMatch = action.type.match(/\/([^/]+)_(failure|success)$/)
    const localLoading = yield select(state => state.loading.localLoading)
    if (actionTypeMatch && actionTypeMatch.length > 1) {
      const key = actionTypeMatch[1]
      const isLoading = localLoading && localLoading[key]
      if (isLoading) {
        yield put(doLocalLoading({ key: actionTypeMatch[1], value: false }))
      }
    }
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function * rootSaga () {
  yield all([
    watchSetLoading(),
    watchUnSetLoading()
    // @generator saga:fork
  ])
}
